var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 12.6666C8.63065 12.6666 9.20665 12.5979 9.73199 12.4792L8.56065 11.3079C8.37865 11.3219 8.19399 11.3332 7.99999 11.3332C4.43265 11.3332 3.05065 8.76923 2.71599 7.9999C2.96728 7.4391 3.30668 6.92213 3.72132 6.46856L2.78932 5.53656C1.76399 6.6479 1.37532 7.76723 1.36799 7.78923C1.322 7.92614 1.322 8.07432 1.36799 8.21123C1.38199 8.25523 2.91132 12.6666 7.99999 12.6666ZM7.99999 3.33323C6.77532 3.33323 5.76932 3.59723 4.93065 3.98723L2.47132 1.52856L1.52865 2.47123L13.5287 14.4712L14.4713 13.5286L12.2587 11.3159C14.0013 10.0152 14.6233 8.23923 14.6327 8.21123C14.6786 8.07432 14.6786 7.92614 14.6327 7.78923C14.618 7.74456 13.0887 3.33323 7.99999 3.33323ZM11.3147 10.3719L9.79465 8.8519C9.92132 8.5919 9.99999 8.3059 9.99999 7.9999C9.99999 6.9059 9.09399 5.9999 7.99999 5.9999C7.69399 5.9999 7.40799 6.07856 7.14865 6.2059L5.94332 5.00056C6.605 4.77351 7.30046 4.66056 7.99999 4.66656C11.5673 4.66656 12.9493 7.23056 13.284 7.9999C13.0827 8.46123 12.5067 9.56123 11.3147 10.3719Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.ab53b1f0564f4a0ff4f44a660de25e58.svg";
export { ForwardRef as ReactComponent };